import type { FC, HTMLAttributes } from "react";

export type FormGroupUIProps = HTMLAttributes<HTMLElement>;

export const FormGroupUI: FC<FormGroupUIProps> = ({ children, className }) => {
  return (
    <div className={`flex space-x-3 items-center ${className}`}>{children}</div>
  );
};
